import React from 'react';
interface ToothIconProps {
  className?: string;
  strokeWidth?: number;
}
export function ToothIcon({
  className = 'w-6 h-6',
  strokeWidth = 2
}: ToothIconProps) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true" data-id="element-241" data-mp="39m27ctwnom47">
      <path d="M7 3c-2.2 0-4 1.6-4 4.5 0 2.4 1 4 1.5 6.5.6 3 1 7 2.8 7 1.7 0 1.9-3.2 2.4-5 .3-1 .8-1.5 2.3-1.5s2 .5 2.3 1.5c.5 1.8.7 5 2.4 5 1.8 0 2.2-4 2.8-7 .5-2.5 1.5-4.1 1.5-6.5C21 4.6 19.2 3 17 3c-2 0-3 1-5 1S9 3 7 3Z" data-id="element-242" data-mp="2gxmtiap9g9ug" />
      <path d="M9 6.5c1 .5 2 .7 3 .7" data-id="element-243" data-mp="2lwhbxbjbfwe1" />
    </svg>;
}